// extracted by mini-css-extract-plugin
export default {"SearchForm":"CitiesPage_SearchForm__-Kp72","SearchForm__input":"CitiesPage_SearchForm__input__-epBc","SearchForm__button":"CitiesPage_SearchForm__button__o7BMO"};